export default __webpack_public_path__ + "static/media/image.digital-pulz-pvt-ltd-.a4855367.png";